import Main from './Main';

export default Main;



// WEBPACK FOOTER //
// ./src/Components/Main/index.tsx